import { DataBean } from "../DataBean";

export class UnCheckBanking extends DataBean {


    public async uncheckBankingConciliationData(idBankingConciliationData:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliationData_uncheckBankingConciliationData_Number", [idBankingConciliationData]);
    }

}